import { DataService } from '../../shared/dataservice.service';
import { Component, OnInit, OnDestroy, ViewChild, Input ,AfterViewInit, OnChanges} from '@angular/core';
import { SalesOrder, UiSoOrder, UiSummarySO, SubSalesOrder, FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, UiWaitReadySO, CommentsPR, PmTechnicalIP, Equipment } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';
import * as XLSX from 'xlsx';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-kpis-v2',
  templateUrl: './kpis-v2.component.html',
  styleUrls: ['./kpis-v2.component.css']
})

export class KpisV2Component implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  _soObjList3: Array<SalesOrder>;


  filteredSOCount3: number = 0;
  filteredSSOCount3: number = 0;

  isLoading3: boolean = false;

  isDataViewUpdated3: boolean = false;
  isGsMonthFilterSelected3: boolean = false;
  gsMonthFilter3: monthFilter;
  isZN1FilterSelected: boolean = true;
  isZS9FilterSelected: boolean = true;
  isZS1FilterSelected: boolean = true;
  isZS1DBBFilterSelected: boolean = true;
  isZS2FilterSelected: boolean = true;
  isInHsFilterSelected: boolean = true;
  isBgoutFilterSelected: boolean = true;

  tptTrendData: any;
  tptTrendKpiChartOptions: Highcharts.Options;

  tptBucketData: any;
  tptBucketKpiChartOptions: Highcharts.Options;
  updateFromInput:boolean = false;


  series = [];

  chartOptions: any;
  Highcharts: typeof Highcharts = Highcharts;
  chartRef:  Highcharts.Chart;

  pnlQty: number = 0;
  baseLn: number = 0;
  trgt: number = 0;
  totalTpt: number = 0;

  ConsWH: number = 0;
  ConsAtLine: number = 0;
  ConsAtTTL: number = 0;
  ConsAtFAT: number = 0;
  ConsAftFAT: number = 0;

  tptBaselineData: any;
  tptBaselineChartOptions: Highcharts.Options;
  
  tptActualData: any;
  tptActualChartOptions: Highcharts.Options;

  constructor(public _dataService3: DataService, private _genService: GenService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }
    ngOnInit(){
      this._dataService3.currPageName = 'TPT + Metric';
      try {
        this.loadSettingsFromCookies();
      } catch (e) {
        console.log(e);
      }

    this.loadData();
  }

  saveSettingsToCookies() {
    this._dataService3.setCookie('s-gsmonth-sel3', this.isGsMonthFilterSelected3 ? "1" : "0");
    if (this.isGsMonthFilterSelected3) {
      this._dataService3.setCookie('s-gsmonth-val3', this.gsMonthFilter3.getCookieStr());
    }
    this._dataService3.setCookie('s-zn1-sel3', this.isZN1FilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-zn9-sel3', this.isZS9FilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-zs1-sel3', this.isZS1FilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-zs1dbb-sel3', this.isZS1DBBFilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-zs2-sel3', this.isZS2FilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-inhs-sel3', this.isInHsFilterSelected ? "1" : "0");
    this._dataService3.setCookie('s-bgout-sel3', this.isBgoutFilterSelected ? "1" : "0");

  }
  loadSettingsFromCookies() {
    let _tmpGsMonthSel: string = this._dataService3.getCookie('s-gsmonth-sel3');
    if (_tmpGsMonthSel) {
      this.isGsMonthFilterSelected3 = (_tmpGsMonthSel == "1");

      let _tmpGsMonthVal: string = this._dataService3.getCookie('s-gsmonth-val3');
      if (_tmpGsMonthVal) {
        this.gsMonthFilter3 = monthFilter.getObjFromCookieStr(_tmpGsMonthVal);
      }
    }

    let _tmpZn1Sel: string = this._dataService3.getCookie('s-zn1-sel3');
    if (_tmpZn1Sel) {
      this.isZN1FilterSelected = (_tmpZn1Sel == "1");
    }

    let _tmpZn9Sel: string = this._dataService3.getCookie('s-zn9-sel3');
    if (_tmpZn9Sel) {
      this.isZS9FilterSelected = (_tmpZn9Sel == "1");
    }
    let _tmpZs1Sel: string = this._dataService3.getCookie('s-zs1-sel3');
    if (_tmpZs1Sel) {
      this.isZS1FilterSelected = (_tmpZs1Sel == "1");
    }
    let _tmpZs1dbbSel: string = this._dataService3.getCookie('s-zs1dbb-sel3');
    if (_tmpZs1dbbSel) {
      this.isZS1DBBFilterSelected = (_tmpZs1dbbSel == "1");
    }
    let _tmpZs2Sel: string = this._dataService3.getCookie('s-zs2-sel3');
    if (_tmpZs2Sel) {
      this.isZS2FilterSelected = (_tmpZs2Sel == "1");
    }
    let _tmpInHsSel: string = this._dataService3.getCookie('s-inhs-sel3');
    if (_tmpInHsSel) {
      this.isInHsFilterSelected = (_tmpInHsSel == "1");
    }
    let _tmpBgoutSel: string = this._dataService3.getCookie('s-bgout-sel3');
    if (_tmpBgoutSel) {
      this.isBgoutFilterSelected = (_tmpBgoutSel == "1");
    }

    let _currDate: Date = new Date();
    if (this.gsMonthFilter3 == null) {
      this.gsMonthFilter3 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading3 = true;
    this._dataService3.getDataDefinitions().subscribe(res => {
      this._dataService3.getAllSalesOrder_2(0).subscribe((_soObjAr3: Array<SalesOrder>) => {
        this._soObjList3 = _soObjAr3

        // this._soObjList3 = _soObjAr3.filter((_tmpSO3:SalesOrder) => {

        //   if(_tmpSO3.projectStatus == SOStatus.Dispatched )
        //   {
        //     return false;
        //   }
        //   return true;
        // });
      
        this.filterRows();


      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading3 = true;
    this.loadData();
  }
  clearFilters(): void {
    this.isGsMonthFilterSelected3 = false;
    this.isZN1FilterSelected = true;
    this.isZS9FilterSelected = true;
    this.isZS1FilterSelected = true;
    this.isZS1DBBFilterSelected = true;
    this.isZS2FilterSelected = true;
    this.isInHsFilterSelected = true;
    this.isBgoutFilterSelected = true;

    this.isLoading3 = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading3 = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading3 = false;
    }, 5);
    this.saveSettingsToCookies();
  }



  private displaySOwithNoSSO() {
    if (this.isGsMonthFilterSelected3 == true || this.isZN1FilterSelected == true || this.isZS9FilterSelected == true ||
      this.isZS1FilterSelected == true || this.isZS1DBBFilterSelected == true || this.isZS2FilterSelected == true
      || this.isInHsFilterSelected == true || this.isBgoutFilterSelected == true 
    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter3: number = 0;
    let _tmpSSOCounter3: number = 0;
    let _dataOrders: any = [];
    let _dataOrdersCons: any = [];
    let _dataPanel: any = [];
    let _dataPanelCons: any = [];
    let _dataTPT: any = [];
    let _dataTPTCons: any = [];
    let _dataTPTConsFinal: any = [];
    let _dataTPTbase: any = [];
    let _dataTPTbaseCons: any = [];
    let _dataTPTtar: any = [];
    let _dataTPTtarCons: any = [];

    let _dataBucketBase:any=[];
    let _tmppnlQty: number = 0;
    let _tmpbaseLn: number = 64;
    let _tmptrgt: number = 36; // was 32 before
    let _tmptotalTpt: number = 0;
  
    let _dataWH: any = [];
    let _dataWHCons: any = [];
    let _dataAtLine: any = [];
    let _dataAtLineCons: any = [];
    let _dataIntTT: any = [];
    let _dataIntTTCons: any = [];
    let _dataAtFAT: any = [];
    let _dataAtFATCons: any = [];
    let _dataAftFAT: any = [];
    let _dataAftFATCons: any = [];
    
    let _dataBucket: any = [];
    let _dataBucketCons: any = [];

    let _tmpConsTPT:number=0;
    let _tmpConsWH:number=0;
    let _tmpConsAtLine:number=0;
    let _tmpConsAtTTL:number=0;
    let _tmpConsAtFAT:number=0;
    let _tmpConsAftFAT:number=0;
    let _tmpConsTPTWaterFall:number =0;
    let _greenStckDate: Date;

    let tempArray:Array<SubSalesOrder>;

    let _showSOWithNoSSO3: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjList3.length; i++) {
      let _tmpSO3: SalesOrder = this._soObjList3[i];

      let _isSOPassedFilter3: boolean = true;
      if (_isSOPassedFilter3 == true) {
        var _filteredSSO3: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO3.subSalesOrder);

        if (_filteredSSO3.length > 0 || (_tmpSO3.subSalesOrder.length == 0 && _showSOWithNoSSO3 == true)) {

          _tmpSOCounter3++;
      
          
          let _equpList = [ "001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"]

          tempArray = _filteredSSO3.filter(eachVal => {
            let opt = eachVal.pmTechSubSalesOrder.equipmentList.some((
                { equipmentType }) => _equpList.includes(equipmentType));
            return opt;
        })

        tempArray.forEach((_tmpSSO3: SubSalesOrder) => {



            // TPT PLUS LOGIC
            var minDate = new Date(2021, 0, 1);// 0 index Month
            minDate.setHours(0, 0, 0, 0);

            if (_tmpSSO3.qualityIP.greenStickerActualDate !== null
              && _tmpSSO3.qualityIP.greenStickerActualDate >= minDate) {
                _tmpSSO3.pmTechSubSalesOrder.equipmentList.forEach((e)=>{
                  if(_equpList.includes(e.equipmentType)){
                  var temp:number = parseInt(e.panelQuantity,10);
                  
                  if(temp > 0 ){            
                  _tmppnlQty += temp;
                }
              }
                });

              _greenStckDate = new Date(+_tmpSSO3.qualityIP.greenStickerActualDate);
              _dataOrders.push({ x: _greenStckDate.setDate(2), y: 1 });

              var qntChart=0;
              _tmpSSO3.pmTechSubSalesOrder.equipmentList.forEach((e)=>{
                if(_equpList.includes(e.equipmentType)){
                var temp:number = parseInt(e.panelQuantity,10);
                
                if(temp > 0 ){            
                  qntChart += temp;
              }
            }
              });
              _dataPanel.push({ x: _greenStckDate.setDate(2), y: qntChart });
              qntChart = 0;

              var _d1 = _tmpSSO3.purchaseMatReceipt.ctPTActualReceiptFirstDate;
              var _d2 = _tmpSSO3.purchaseMatReceipt.meteringBoxActualReceiptDate;
              var _d3 = _tmpSSO3.purchaseMatReceipt.breakerActualReceiptDate;
              var firstDates;
              var _mbenable = _tmpSSO3.purchaseMatReceipt.meteringBoxPlannedReceiptDate_Enable;
              var ctApp = _tmpSSO3.purchaseMatReceipt.ctApplicability;
              var mbApp = _tmpSSO3.purchaseMatReceipt.meteringBoxApplicability;
              var brkrApp = _tmpSSO3.purchaseMatReceipt.breakerApplicability;

              // if( !ctApp || ctApp =="001" ){ 
              //   // NEW FIELD - UNDEFINED IS MADE TO BE 001 BY DEFAULT - HENCE CHECKING FOR UNDEFINED / NULL FIRST
              //   minDates = this.getMinDates3(_d1, _d2, _d3);
              // }
              // else{
              //   minDates = this.getMinDates2(_d2, _d3);
              // }
              var firstDateCheck = [];
              var ctCheck;
              if( !ctApp || ctApp =="001" ){ 
                if(_d1 != null){
                  ctCheck = _d1;
                }
                // else {ctCheck = "NA";}
                else {ctCheck = null;}// TPT+ value wasn't coming for NA index
              }
              else {ctCheck = null;}

              firstDateCheck.push(ctCheck);

              var mbCheck;
              if(_mbenable!=false){
                if(!mbApp || mbApp =="001"){
                  if(_d2 != null){
                    mbCheck = _d2;
                  }
                  // else {mbCheck = "NA";}
                  else {mbCheck = null;}// TPT+ value wasn't coming for NA index
                }
                else  {mbCheck = null;}
              } 
              else {
                // if(_mbenable == false){
                  mbCheck = null;
                // }
              }

              firstDateCheck.push(mbCheck);

             var brkrCheck;
              if( !brkrApp || brkrApp =="001" ){ 
                if(_d3 != null){
                  brkrCheck = _d3;
                }
                // else {brkrCheck = "NA";}
                else {brkrCheck = null;} // TPT+ value wasn't coming for NA index
              }
              else {brkrCheck = null;}

              firstDateCheck.push(brkrCheck);

              const indices = firstDateCheck.reduce(
                (out, bool, index) => bool!=null ? out.concat(index) : out,
                []
              )
              var count = indices.length;
              
              switch(count){
                case 1:
                  firstDates = firstDateCheck[indices[0]].getTime();
                  break;

                case 2:
                  firstDates = this.getMinDates2(firstDateCheck[indices[0]],firstDateCheck[indices[1]]);
                  break;

                case 3:
                  firstDates = this.getMinDates3(firstDateCheck[indices[0]], firstDateCheck[indices[1]], firstDateCheck[indices[2]]);
                  break;

                default : 
                firstDates = _tmpSSO3.productionIP.lineLoadingActualDate.getTime();
                break;

              }

              var tempminDates;
              if (firstDates != 0) {
                tempminDates = new Date(firstDates);
              }
              else tempminDates = null;
              var daysDiff = this.getDaysDiff(_tmpSSO3.qualityIP.greenStickerActualDate, tempminDates);
              _dataTPT.push({ x:_greenStckDate.setDate(2), y: daysDiff, z:1 });
              _dataTPTbase.push({ x: _greenStckDate.setDate(2), y: _tmpbaseLn });

              _dataTPTtar.push({ x: _greenStckDate.setDate(2), y: _tmptrgt });

              var actualLineLoadingDate = _tmpSSO3.productionIP.lineLoadingActualDate;
             var mechanicalStickerDate = _tmpSSO3.productionIP.mechanicalStickerActualDate;
             var internalTestingDate = _tmpSSO3.qualityIP.mechanicalElectricalTestingActualDate;
             var fatTestingDate = _tmpSSO3.qualityIP.fatActualDate;
             var greenStickerDate = _tmpSSO3.qualityIP.greenStickerActualDate;

             var atW = this.getDaysDiff(actualLineLoadingDate,tempminDates);
             var atL = this.getDaysDiff(mechanicalStickerDate,actualLineLoadingDate);
             var intTT = this.getDaysDiff(internalTestingDate,mechanicalStickerDate);
             var atF = this.getDaysDiff(fatTestingDate,internalTestingDate);
             var atAft = this.getDaysDiff(greenStickerDate,fatTestingDate);

             _dataWH.push({ x: _greenStckDate.setDate(2), y: atW, z:1});
             _dataAtLine.push({ x: _greenStckDate.setDate(2), y: atL ,z:1});
             _dataIntTT.push({ x: _greenStckDate.setDate(2), y: intTT ,z:1});
             _dataAtFAT.push({ x: _greenStckDate.setDate(2), y: atF ,z:1});
             _dataAftFAT.push({ x: _greenStckDate.setDate(2), y: atAft ,z:1});

              // TPT+ Bucket wise trend LOGIC


              _tmpSSOCounter3++;
            }

          });


        }


      }

    }
    
    _dataTPT.sort(function (a, b) {
      return a.x - b.x;
    })
    this.groupByDates(_dataOrders, _dataOrdersCons);
    this.groupByDates(_dataPanel, _dataPanelCons);
    this.groupByDates3(_dataTPT, _dataTPTCons);
    this.groupByDatesForConst(_dataTPTbase, _dataTPTbaseCons);
    this.groupByDatesForConst(_dataTPTtar, _dataTPTtarCons);

    this.groupByDates3(_dataWH, _dataWHCons);
    this.groupByDates3( _dataAtLine,  _dataAtLineCons);
    this.groupByDates3( _dataIntTT,  _dataIntTTCons);
    this.groupByDates3(_dataAtFAT, _dataAtFATCons);
    this.groupByDates3(_dataAftFAT, _dataAftFATCons);
   
    var TPTCmltive :number = 0;
    var TPTCmltiveCount :number = 0;
    var whCmltive :number = 0;
    var whCmltiveCount :number = 0;
    var atLCmltive :number = 0;
    var atLCmltiveCount :number = 0;
    var intTTLCmltive :number = 0;
    var intTTLCmltiveCount :number = 0;
    var atFCmltive :number = 0;
    var atFCmltiveCount :number = 0;
    var aftFCmltive :number = 0;
    var aftFCmltiveCount :number = 0;

    _dataTPTCons.forEach(element => {
      _dataTPTConsFinal.push({x:element.x,y:Math.round(element.y/element.z)});
      // TPTCmltive += Math.round(element.y/element.z);  
      // TPTCmltiveCount++;
      TPTCmltive += element.y;  
      TPTCmltiveCount+= element.z;
    });
    _tmpConsTPT = Math.round(TPTCmltive/TPTCmltiveCount);    
    if(isNaN(_tmpConsTPT)){
      _tmpConsTPT = 0;
    }

    _dataWHCons.forEach(element => {
      _dataBucket.push({x:element.x,y:Math.round(element.y/element.z)});
      whCmltive += element.y;  
      whCmltiveCount+= element.z;
    });
    _tmpConsWH = Math.round(whCmltive/whCmltiveCount);    
    if(isNaN(_tmpConsWH)){
      _tmpConsWH = 0;
    }

    _dataAtLineCons.forEach(element => {
      _dataBucket.push({x:element.x,y:Math.round(element.y/element.z)});
      atLCmltive += element.y;  
      atLCmltiveCount+= element.z;
    });
    _tmpConsAtLine = Math.round(atLCmltive/atLCmltiveCount);
    if(isNaN(_tmpConsAtLine)){
      _tmpConsAtLine = 0;
    }

    _dataIntTTCons.forEach(element => {
      _dataBucket.push({x:element.x,y:Math.round(element.y/element.z)});
      intTTLCmltive += element.y;  
      intTTLCmltiveCount+= element.z;
    });
    _tmpConsAtTTL = Math.round(intTTLCmltive/intTTLCmltiveCount);
    if(isNaN(_tmpConsAtTTL)){
      _tmpConsAtTTL = 0;
    }

    _dataAtFATCons.forEach(element => {
      _dataBucket.push({x:element.x,y:Math.round(element.y/element.z)});
      atFCmltive += element.y;  
      atFCmltiveCount+= element.z;
    });
    _tmpConsAtFAT = Math.round(atFCmltive/atFCmltiveCount);
    if(isNaN(_tmpConsAtFAT)){
      _tmpConsAtFAT = 0;
    }

    _dataAftFATCons.forEach(element => {
      _dataBucket.push({x:element.x,y:Math.round(element.y/element.z)});
      aftFCmltive +=element.y;  
      aftFCmltiveCount+= element.z;
    });     
    _tmpConsAftFAT = Math.round(aftFCmltive/aftFCmltiveCount);
    if(isNaN(_tmpConsAftFAT)){
      _tmpConsAftFAT = 0;
    }


    const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // const monthsColor = [  "#6e6e6e","#a9a9a9", "#d2d2d2",  "#6e6e6e","#a9a9a9", "#d2d2d2",  "#6e6e6e","#a9a9a9","#d2d2d2","#6e6e6e","#a9a9a9", "#d2d2d2",];
    const monthsColor = [  "#3c1361","#663a82", "#922B3E",  "#ff000f","#ff5349", "#ffa500",  "#FE8116","#FFCF07","#9ACD32","#388E3C","#007373", "#072F5F",];

  var grpTmp = this.groupByBT(_dataBucket,'x');

  for (const key in grpTmp) {
    _dataBucketCons.push({x:Number(key),y:grpTmp[key]});
}

_dataBucketCons.sort(function (a, b) {
  return a.x - b.x;
})

_dataBucketBase.push({name:'Baseline',type:'column',color:"#ff000f",data:[23, 7, 13, 12, 9]});

  _dataBucketCons.forEach(element => {
    let a = new Date(element.x);
    let b = a.getFullYear().toString();
    let bTemp = b.substring(2);
    
    let formatted_date = months[a.getMonth()] + " " + bTemp;
    _dataBucketBase.push({name:formatted_date,type:'column',color:monthsColor[a.getMonth()],data:element.y});
  }); 

  _dataBucketBase.push({name:'Cummulaive',type:'column',color:"#262626",data:[_tmpConsWH, _tmpConsAtLine, _tmpConsAtTTL, _tmpConsAtFAT, _tmpConsAftFAT]});

    
    if (_dataOrders.length !== 0 || _dataPanel.length !== 0 || _dataTPT.length !== 0) {
      this.tptTrendData = [{
        name: 'Order',
        type: 'column',
        yAxis: 1,
        color: '#595959',
        data: _dataOrdersCons,
      },
      {
        name: 'Panel',
        type: 'column',
        yAxis: 1,
        color: '#ff000f',
        data: _dataPanelCons

      },
      {
        name: 'TPT+',
        color: '#262626',
        data: _dataTPTConsFinal

      },
      {
        name: 'Baseline',
        color: '#C00000',
        data: _dataTPTbaseCons

      },
      {
        name: 'Target',
        color: '#A5A5A5',
        data: _dataTPTtarCons

      }

      ];
    }
    else this.tptTrendData = null;

    this.tptTrendKpiChartOptions = this._kpiCharServ.getComboChartOptions(this, this.tptTrendData);


    if(_dataBucketBase.length!=0){
      this.tptBucketData = _dataBucketBase;

    }
  else  this.tptBucketData = null;

    //////////////////////////
    this.chartOptions = {
      chart: {
          type: 'column'
      },
      title: {
        text: '',
        style:{
          fontFamily:'abb-voice',
          fontSize:'10pt',
          fontWeight:'bold'
        }
      },
      xAxis: {
        categories: ["At Wearhouse","At Line","Internal Testing Time","At FAT","After FAT"],
      },
      yAxis: {
          title: {
              text: 'DAYS'
          }
      },
      tooltip: {
          split: false,
      
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        line: {
            dataLabels: {
                enabled: false
            }
        }
    },
      series: this.tptBucketData
  };

if(this.chartRef!= undefined){ // This is to remove the error from console  
this.removeAll();//remove all the series from the chart

   this.series = [];//clear die series object
  //this for loop creates the new number of series and then populates the series object
   for (let i = 0; i< this.tptBucketData.length; i++){
    this.chartRef.addSeries({
      type: 'column',
      name: 'array',
      data: [0],
      color:'color'
    }, false);

    this.series.push({name: this.tptBucketData[i].name, color:this.tptBucketData[i].color , data: this.tptBucketData[i].data});
  }

   this.chartOptions.series = this.series;
  }
   this.updateFromInput = true;

   this.tptBaselineData = [{
    "data": [{
       name: 'At Wearhouse',
       color: '#6e6e6e',
       y: 23,
     },
     {
       name: 'At Line',
       color: '#6e6e6e',
       y: 7,
     },
     {
       name: 'Internal Test',
       color: '#6e6e6e',
       y: 13,
     },
     {
       name: 'At FAT',
       color: '#6e6e6e',
       y: 12,
     },
     {
       name: 'After FAT',
       color: '#6e6e6e',
       y: 9,
     },
     {
       name: 'TPT +',
       color: '#6e6e6e',
       y: 64,
     }]
    }
       
   ];
   this.tptBaselineChartOptions = this._kpiCharServ.getWaterFallChartOptions(this, this.tptBaselineData,1);

   if(_tmpConsWH!=null || _tmpConsAtLine!=null || _tmpConsAtTTL!=null || _tmpConsAtFAT!=null || _tmpConsAftFAT!=null ){
   this.tptActualData = [{
    "data": [{
       name: 'At Wearhouse',
       color: '#ff000f',
       y: _tmpConsWH, 
     },
     {
       name: 'At Line',
       color: '#ff000f',
       y: _tmpConsAtLine, 
     },
     {
       name: 'Internal Test',
       color: '#ff000f',
       y: _tmpConsAtTTL,
     },
     {
       name: 'At FAT',
       color: '#ff000f',
       y:  _tmpConsAtFAT, 
     },
     {
       name: 'After FAT',
       color: '#ff000f',
       y: _tmpConsAftFAT,
     },
     {
       name: 'TPT +',
       color: '#ff000f',
      //  isSum: true,
       y: _tmpConsTPT
     }]
    }
       
   ];}

   else this.tptActualData = null;

   this.tptActualChartOptions = this._kpiCharServ.getWaterFallChartOptions(this, this.tptActualData,2);
  
   this.filteredSOCount3 = _tmpSOCounter3;
   this.filteredSSOCount3 = _tmpSSOCounter3;
   this.pnlQty = _tmppnlQty;
   this.baseLn = _tmpbaseLn;
   this.trgt = _tmptrgt;
  //  this.totalTpt = _tmptotalTpt;
   this.totalTpt = _tmpConsTPT;
   this.ConsWH = _tmpConsWH;
   this.ConsAtLine = _tmpConsAtLine;
   this.ConsAtTTL = _tmpConsAtTTL;
   this.ConsAtFAT = _tmpConsAtFAT;
   this.ConsAftFAT = _tmpConsAftFAT;
  //  console.log("SSO", _tmpSSOCounter3);

    /////////////////////////////
    
    this.isDataViewUpdated3 = true;
    setTimeout(() => {
      this.isDataViewUpdated3 = false;
    }, 1000);
  }

  chartCallback: Highcharts.ChartCallbackFunction = (chart) => {
    this.chartRef = chart;
  };

  getGsMonthLabel(): string {
    if (this.isGsMonthFilterSelected3 == true) {
      return "Green Sticker Month : ";
    }
    else {
      return "Enable Green Sticker Month Filter";
    }
  }

  getGsFromMonthName(): string {
    if (this.gsMonthFilter3) {
      return this.gsMonthFilter3.fromMonthName;
    }
    return '';
  }
  getGsToMonthName(): string {
    if (this.gsMonthFilter3) {
      return this.gsMonthFilter3.toMonthName;
    }
    return '';
  }

  gsPrevFromMonth() {
    this.gsMonthFilter3.prevFromMonth();
    this.filterRows();
  }
  gsNextFromMonth() {
    this.gsMonthFilter3.nextFromMonth();
    this.filterRows();
  }
  gsPrevToMonth() {
    this.gsMonthFilter3.prevToMonth();
    this.filterRows();
  }
  gsNextToMonth() {
    this.gsMonthFilter3.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      // if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
   
      if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == '-') == true) return false;

      //check if revenue month 
      if (this.isGsMonthFilterPassed(_sso.qualityIP.greenstickermonth) == false) return false;
      // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
      // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;


      if (this.isZN1FilterSelected == false) {
        if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == 'LG ZN1') == true) return false;
      }
      if (this.isZS9FilterSelected == false) {
        if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == 'LG ZS9') == true) return false;
      }
      if (this.isZS1FilterSelected == false) {
        if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == 'UG ZS1') == true) return false;
      }
      if (this.isZS1DBBFilterSelected == false) {
        if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == 'UG ZS1 DBB') == true) return false;
      }
      if (this.isZS2FilterSelected == false) {
        if ((this._dataService3.getProductVariantName(_sso.pmTechSubSalesOrder.productVarient) == 'UG ZS2') == true) return false;
      }
      if (this.isInHsFilterSelected == false) {
        if (_sso.planningIP.manufacturingStrategyInhouse_Enable == true) return false;
      }
      if (this.isBgoutFilterSelected == false) {
        if (_sso.planningIP.manufacturingStrategyInhouse_Enable == false) return false;
      }


      return true;
    });
  }

  private isGsMonthFilterPassed(_grnStckrMonth: Date) {
    if (this.isGsMonthFilterSelected3 == true && this.gsMonthFilter3 != null) {
      if (this.gsMonthFilter3.isWithInFilterScope(_grnStckrMonth) == false) {
        return false;
      }
    }
    return true;
  }

  private groupByDates(array, result) {
    array.reduce(function (res, value) {
      if (!res[value.x]) {
        res[value.x] = { x: value.x, y: 0 };
        result.push(res[value.x])
      }
      res[value.x].y += value.y;
      return res;
    }, {});
  }

  private groupByDatesForConst(array, result) {
    array.reduce(function (res, value) {
      if (!res[value.x]) {
        res[value.x] = { x: value.x, y: 0 };
        result.push(res[value.x])
      }
      res[value.x].y = value.y;
      return res;
    }, {});
  }

  private groupByDates3(array, result) {
    array.reduce(function (res, value) {
      if (!res[value.x]) {
        res[value.x] = { x: value.x, y: 0,z:0 };
        result.push(res[value.x])
      }
      res[value.x].y += value.y;
      res[value.x].z += value.z;
      return res;
    }, {});
  }

  private getMinDates3(_date1, _date2, _date3) {
    var temp_1, temp_2, temp_3;
    if(_date1 != null && _date1 != "NA"){
      temp_1 = _date1.getTime();
    }
    else temp_1 = null;

    if(_date2 != null && _date2 != "NA"){
      temp_2 = _date2.getTime();
    }
    else temp_2 = null;

    if(_date3 != null && _date3 != "NA"){
      temp_3 = _date3.getTime();
    }
    else temp_3 = null;

    return Math.min(temp_1,temp_2,temp_3);
  }

  private getMinDates2(_date1, _date2) {
    var temp_1, temp_2;
    if(_date1 != null && _date1 != "NA"){
      temp_1 = _date1.getTime();
    }
    else temp_1 = null;

    if(_date2 != null && _date2 != "NA"){
      temp_2 = _date2.getTime();
    }
    else temp_2 = null;

    return Math.min(temp_1,temp_2);
  }
  private getDaysDiff(_date1: Date, _date2: Date) {
    if (_date1 != null && _date2 != null) {
      var a = _date1.getTime();
      var b = _date2.getTime();

      var timeDiff = a - b;
      return Math.round(timeDiff / 86400000);//24 * 3600 * 1000  =86400000
    }
    else return 0;
  }
////////////////////////////////////

private removeAll(){
  while (this.chartRef.series.length) {
    // console.log(_chartRef.series[0]);
    this.chartRef.series[0].remove();
  }
}

groupByBT(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    let key = obj[property]
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(obj['y'])
    return acc
  }, {})
}

}
